if (!customElements.get('atc-upsell-modal')) {
  customElements.define(
    'atc-upsell-modal',
    class AtcUpsellModal extends HTMLElement {
      connectedCallback() {
        this.variantIds = this.parseJSON(this.dataset.variantIds);

        window.customElements.whenDefined('cart-drawer').then(() => {
          this.drawer = document.querySelector('cart-drawer');
          if (!this.drawer || this.drawer.dataset.atcModalPatched) return;
          this.drawer.dataset.atcModalPatched = 'true';
          const originalOpen = this.drawer.open.bind(this.drawer);
          this.drawer.openDirect = originalOpen;
          const modal = this;
          this.drawer.open = function (triggeredBy) {
            if (modal.suppressDrawer) {
              modal.suppressDrawer = false;
              return;
            }
            originalOpen(triggeredBy);
          };
        });

        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source !== 'product-form') return;
          if (!this.variantIds.includes(Number(event.productVariantId))) {
            if (!this.hidden) this.hide();
            return;
          }
          this.suppressDrawer = true;
          this.show(event.cartData);
        });

        this.querySelectorAll('[data-atc-modal-close]').forEach((element) => {
          element.addEventListener('click', () => this.hide());
        });
        this.onKeyDown = (event) => {
          if (event.key === 'Escape' && !this.hidden) this.hide();
        };
        document.addEventListener('keydown', this.onKeyDown);
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        this.adoptedModals?.forEach((modal) => modal.remove());
        document.removeEventListener('keydown', this.onKeyDown);
        if (this.drawer?.openDirect) {
          this.drawer.open = this.drawer.openDirect;
          delete this.drawer.dataset.atcModalPatched;
        }
      }

      parseJSON(value) {
        try {
          return JSON.parse(value || '[]');
        } catch {
          return [];
        }
      }

      formatPrice(cents) {
        return window.chilloutFormatMoney(cents, this.dataset.moneyFormat);
      }

      show(item) {
        if (item) this.fillProduct(item);
        this.loadRecommendations();
        this.removeAttribute('hidden');
        document.body.classList.add('overflow-hidden');
        this.querySelector('.atc-modal__close')?.focus();
      }

      hide() {
        this.setAttribute('hidden', '');
        document.body.classList.remove('overflow-hidden');
        this.suppressDrawer = false;
        if (this.drawer) (this.drawer.openDirect || this.drawer.open).call(this.drawer);
      }

      fillProduct(item) {
        const image = this.querySelector('[data-atc-modal-image]');
        if (image && item.image) {
          try {
            const url = new URL(item.image);
            url.searchParams.set('width', '240');
            image.src = url.toString();
          } catch {
            image.src = item.image;
          }
          image.alt = item.product_title || '';
          image.removeAttribute('hidden');
        }

        const name = this.querySelector('[data-atc-modal-name]');
        if (name) name.textContent = item.product_title || '';

        const variant = this.querySelector('[data-atc-modal-variant]');
        if (variant) {
          const options = (item.options_with_values || [])
            .map((option) => `${option.name}: ${option.value}`)
            .join(' · ');
          variant.textContent = options;
          variant.hidden = !options;
        }

        const price = this.querySelector('[data-atc-modal-price]');
        if (price && item.final_price != null) {
          price.textContent = this.formatPrice(item.final_price);
        }
      }

      loadRecommendations() {
        if (this.recsState) return;
        this.recsState = 'loading';

        fetch(this.dataset.recommendationsUrl)
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.text();
          })
          .then((text) => {
            const grid = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('[data-cross-sell-grid]');
            if (!grid || !grid.querySelector('.grid__item')) return;

            grid.querySelectorAll('quick-add-modal[id]').forEach((modal) => {
              modal.setAttribute('id', modal.getAttribute('id') + '-atc');
            });
            grid.querySelectorAll('modal-opener[data-modal]').forEach((opener) => {
              opener.setAttribute('data-modal', opener.getAttribute('data-modal') + '-atc');
            });
            const modalIds = [...grid.querySelectorAll('quick-add-modal[id]')].map((modal) =>
              modal.getAttribute('id')
            );

            this.adoptedModals?.forEach((modal) => modal.remove());
            const holder = this.querySelector('[data-atc-modal-recs]');
            holder.innerHTML = grid.outerHTML;
            holder.querySelectorAll('quick-add-modal').forEach((modal) => document.body.appendChild(modal));
            this.adoptedModals = modalIds.map((id) => document.getElementById(id)).filter(Boolean);

            this.querySelector('.atc-modal__recs').removeAttribute('hidden');
            this.recsState = 'loaded';
          })
          .catch((error) => {
            console.error('[atc-upsell-modal]', error);
            this.recsState = null;
          });
      }
    }
  );
}
